(function ($) {
    $(document).ready(function () {

        const hasSeenPopup = sessionStorage.getItem('newsletter-popup');
        if (!hasSeenPopup) {
            setTimeout(function () {
                $('#newsletter-popup').modal();
                const modal = new bootstrap.Modal(document.getElementById('newsletter-popup'), {
                    keyboard: false
                });
                modal.show();
                sessionStorage.setItem('newsletter-popup', '1');
            }, 1000);
        }

    });
})(jQuery);
